module.exports = __webpack_public_path__ + "static/jonathan-agoot-speaking-engagements-0223eac036ebddb0695c151c673d03b7.jpg";